import { createContext, useState, useEffect } from "react";
import { request } from "../utils/api";

export const AuthContext = createContext();
const ABILITY_REFRESH_EVENT = "yobas:ability-refresh";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const userData = localStorage.getItem("user");

    if (token) {
      setUser({ token, ...(userData ? JSON.parse(userData) : {}) });
    }

    setLoading(false);
  }, []);

  const notifyAbilityRefresh = () => {
    window.dispatchEvent(new Event(ABILITY_REFRESH_EVENT));
  };

  const storeDataInLocalStorage = (response) => {
    const { access_token, user, expires_in } = response;
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("yobas_role", JSON.stringify(user.role_key));
    localStorage.setItem(
      "permissions",
      JSON.stringify(user.permissions.map((p) => p.key))
    );
    localStorage.setItem("expire", expires_in);

    setUser({ access_token, ...user });
    notifyAbilityRefresh();
  };

  const removeDataInLocalStorage = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
    localStorage.removeItem("expire");
    localStorage.removeItem("yobas_role");
    setUser(null);
    notifyAbilityRefresh();
  };

  const login = async (email, password) => {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    let response = [];
    try {
      response = await request({
        url: "login",
        method: "POST",
        data: formData,
      });
      storeDataInLocalStorage(response);
      return { isError: false, response: response };
    } catch (error) {
      return { isError: true, error: error };
    }
  };

  const logoutUser = async () => {
    try {
      await request({
        url: "logout",
        method: "POST",
        data: {},
      });
    } catch (err) {}
  };

  const logout = () => {
    removeDataInLocalStorage();
    logoutUser();
  };

  const updatePermission = (permissions) =>{
    localStorage.removeItem("permissions");
    const permissionKeys = permissions.map((p) =>
      typeof p === "string" ? p : p.key
    );
    localStorage.setItem(
      "permissions",
      JSON.stringify(permissionKeys)
    );
    notifyAbilityRefresh();
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, updatePermission }}>
      {children}
    </AuthContext.Provider>
  );
};
